import { ShareLineItemScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ShareLineItemScreen />;
}
